import { createOpenAnalystClient } from "@openanalyst-ai/sdk/v2/client"
import type { ServerConnection } from "@/context/server"

export function authFromToken(token: string) {
  try {
    const decoded = atob(token)
    const separator = decoded.indexOf(":")
    if (separator === -1) return
    return {
      username: decoded.slice(0, separator) || "openanalyst",
      password: decoded.slice(separator + 1),
    }
  } catch {
    return
  }
}

export function authTokenFromCredentials(input: { username?: string | null; password: string }) {
  return btoa(`${input.username || "openanalyst"}:${input.password}`)
}

export function createSdkForServer({
  server,
  ...config
}: Omit<NonNullable<Parameters<typeof createOpenAnalystClient>[0]>, "baseUrl"> & {
  server: ServerConnection.HttpBase
}) {
  const auth = (() => {
    if (!server.password) return
    return {
      Authorization: `Basic ${btoa(`${server.username ?? "openanalyst"}:${server.password}`)}`,
    }
  })()

  return createOpenAnalystClient({
    ...config,
    headers: {
      ...(config.headers instanceof Headers ? Object.fromEntries(config.headers.entries()) : config.headers),
      ...auth,
    },
    baseUrl: server.url,
  })
}
